import React, { FC, PropsWithChildren, useRef } from 'react';
import { Container } from './styled';
import { CSSObject } from 'styled-components';

interface IProps {
    gap: number;
    setDraggable?: (isDraggable: boolean) => void;
    styles?: CSSObject;
}

const ScrollAndDrag: FC<PropsWithChildren<IProps>> = ({ children, gap, setDraggable, styles }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const isDown = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);
    const DRAG_THRESHOLD = 5; // px

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (!containerRef.current) return;

        isDown.current = true;
        if (setDraggable) setDraggable(false);
        startX.current = e.pageX - containerRef.current.offsetLeft;
        scrollLeft.current = containerRef.current.scrollLeft;

        containerRef.current.classList.add('active');
        containerRef.current.style.cursor = 'grabbing';
        containerRef.current.style.userSelect = 'none';
    };

    const handleMouseLeaveOrUp = () => {
        if (!containerRef.current) return;

        isDown.current = false;
        containerRef.current.classList.remove('active');
        containerRef.current.style.cursor = 'grab';
    };

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (!containerRef.current || !isDown.current) return;

        e.preventDefault();
        const x = e.pageX - containerRef.current.offsetLeft;
        const walk = (x - startX.current) * 1.5;

        if (Math.abs(walk) > DRAG_THRESHOLD && setDraggable) {
            setDraggable(true);
        }

        containerRef.current.scrollLeft = scrollLeft.current - walk;
    };

    return (
        <Container
            gap={gap}
            ref={containerRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeaveOrUp}
            onMouseUp={handleMouseLeaveOrUp}
            onMouseMove={handleMouseMove}
            styles={styles}
        >
            {children}
        </Container>
    );
};

export default ScrollAndDrag;
